import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NotificationsPayloadType, NotificationsStateType } from '../types'

const initialState: NotificationsStateType = {
  notificationsListData: [],
  notificationsListPaginatedData: [],
  totalPages: null,
}
const notificationSlice = createSlice({
  name: 'notifications',
  initialState: initialState,
  reducers: {
    getNotificationsListData: () => {
      return
    },
    updateNotificationsListData: (state, action) => {
      state.notificationsListData = action?.payload
    },
    getNotificationsListPaginatedData: (
      _state,
      _action: PayloadAction<NotificationsPayloadType>
    ) => {
      return
    },
    updateNotificationsListPaginatedData: (state, action) => {
      state.notificationsListPaginatedData = action?.payload?.content
      state.totalPages = action?.payload?.totalPages
    },
  },
})

export const {
  getNotificationsListData,
  updateNotificationsListData,
  getNotificationsListPaginatedData,
  updateNotificationsListPaginatedData,
} = notificationSlice.actions

export default notificationSlice.reducer
